.page {
  background: var(--ib-blush);
  padding: 22px 24px 60px;
  min-height: 100%;
}

.pagehead {
  margin: 0 0 16px;
}

.pageTitle {
  font-family: var(--font-serif);
}

@media only screen and (max-width: 550px) {
  .page {
    padding: 16px 14px 40px;
  }
}
